import { VStack } from "@chakra-ui/react";
import LogTable from "../components/log_page/log_table"
import { useStores } from "../store/store_context";

const LogPage = () => {
  const { pageStore } = useStores();
  return (
    <VStack w="100%" minH="100vh" align="center">
      <LogTable data={pageStore.data_logs}/>
    </VStack>
  );
};

export default LogPage;